module.exports = "/images/no-jobs-types.svg?e2daa7bcd9555fb53709a64b2759b919";